export default __webpack_public_path__ + "static/Pranjal-0f431363b3b2546327822892bb4f9395.png";